// extracted by mini-css-extract-plugin
export default {"price":"k7-z","priceRow":"l7-z","onSale":"m7-z","msrpLabelPrice":"n7-z","msrpLabel":"o7-z","originalPrice":"p7-z","percentOff":"q7-z"};